<template>
  <div style="padding:10px 0;">

    <!--level  -->
    <div :class="data.TypeName  == 'Super Manager' ||data.TypeName  == 'Manager' ? '' :'le-bord'">
        <template v-if="data.TypeName  == 'Super Manager' ||data.TypeName  == 'Manager'">
            <div class="level">
                <Breadcrumb :headers="headers"></Breadcrumb> 
                <span style="padding-right:400px;">Your Grade is: {{data.GradeName || data.TypeName}}</span>  
                <label></label>      
        </div>
        </template>
        <template v-else>
            <div class="level" style="height:285px;">
                <Breadcrumb :headers="headers"></Breadcrumb>
                <span style="padding-right:400px; ">Your Grade is: {{data.GradeName || data.TypeName}}</span>   
                <span v-if="data.GradeName == 'Authorized'">
                    <img src="../assets/images/Authorized.png" style="width: 100px; height: 100px; vertical-align: middle; margin-bottom:8px;">
                </span>
                <span v-else-if="data.GradeName == 'Silver'">
                    <img src="../assets/images/Silver.png" style="width: 100px; height: 100px; vertical-align: middle;margin-bottom:8px;">
                </span>
                <span v-else-if="data.GradeName == 'Gold'">
                    <img src="../assets/images/Gold.png" style="width: 100px; height: 100px; vertical-align: middle;margin-bottom:8px;">
                </span>
                <span v-else-if="data.GradeName == 'Platinum'">
                    <img src="../assets/images/Platinum.png" style="width: 100px; height: 100px; vertical-align: middle;margin-bottom:8px;">
                </span>
                <span v-else-if="data.GradeName == 'Distributor'">
                    <img src="../assets/images/Distributor.png" style="width: 100px; height: 100px; vertical-align: middle;margin-bottom:8px;">
                </span>

                <span v-if="data.GradeName  == 'Authorized' || data.GradeName  == 'Silver' || data.GradeName  == 'Gold' || data.GradeName  == 'Platinum' || data.GradeName  == 'Distributor'">
                    <p style="font-size:15px; padding-bottom: 20px;">ACIA(Akuvox Certified Intercom Associate):  {{partnerData.ACIA}}</p>
                    <p style="font-size:15px; padding-bottom: 20px;">ACIP(Akuvox Certified Intercom Profession):  {{partnerData.ACIP}}</p>
                    <p style="font-size:15px;">ACIE(Akuvox Certified Intercom Expert):  {{partnerData.ACIE}}</p> 
                </span>

                <span v-if="data.TypeName  == 'Sales Representative'">
                    <br><br>
                    <button @click="partner()" style="width: 150px; height: 50px; font-size:15px;margin:20px;">
                        All your partners
                    </button>
                   <!--  <p style="padding-bottom: 20px;">Your partners:</p>   
                    <el-button style="margin-bottom: 15px;" v-for="item in userDataList"
                                @click="setPartnerEngineer(item[0])"
                                :key="item[0].ID"
                                :label="item[0].ID"
                                :value="item[0].ID">
                                {{item[0].CompanyName}}
                </el-button> -->
                </span>  
            </div>
        </template>
        <!-- level end  -->

        <template v-if="data.GradeName  == 'Authorized' || data.GradeName  == 'Silver' || data.GradeName  == 'Gold' || data.GradeName  == 'Platinum' || data.GradeName  == 'Distributor'">
            <template>
                <div class="registration" style="height:105px;">
                    <Breadcrumb :headers="headers2"></Breadcrumb>
                    <p class="file" @click="projectRegistration">{{ data.ProjectRegistration}}</p>
                    <label></label>     
                </div>
            </template>
        </template>
        <template v-if="data.TypeName  == 'Super Manager' ||data.TypeName  == 'Manager' || data.TypeName  == 'Sales Representative'">
            <template>
                <div class="registration" style="height:105px;">
                    <Breadcrumb :headers="headers2"></Breadcrumb>
                    <p class="file" @click="projectRegistration">{{ data.ProjectRegistration}}</p>
                    <label></label>     
                </div>
            </template>
        </template>
    </div>


    <template  v-if="data.PartnerRecommend != null && (data.GradeName  == 'Authorized' || data.GradeName  == 'Silver' || data.GradeName  == 'Gold' || data.GradeName  == 'Platinum' || data.GradeName  == 'Distributor')">
        <div class="news" style="height:410px;">
            <Breadcrumb :headers="headers1"></Breadcrumb>
            <br>
            <p class="file" @click="toggle(data.PartnerRecommend.CompanysName)" title="Download">{{ data.PartnerRecommend.CompanysName}}</p>
            <br>
            <p class="file" @click="toggle(data.PartnerRecommend.ProductsName)" title="Download">{{ data.PartnerRecommend.ProductsName}}</p>
            <br>
            <p class="file" @click="toggle(data.PartnerRecommend.SolutionsName)" title="Download">{{ data.PartnerRecommend.SolutionsName}}</p>
            <br>
            <p class="file" @click="toggle(data.PartnerRecommend.ExhibitionsName)" title="Download">{{ data.PartnerRecommend.ExhibitionsName}}</p>
        </div>  
    </template>
     <template v-else-if="(data.GradeName  == 'Authorized' || data.GradeName  == 'Silver' || data.GradeName  == 'Gold' || data.GradeName  == 'Platinum' || data.GradeName  == 'Distributor')">
        <div class="news"  style="height:410px;">
            <Breadcrumb :headers="headers1"></Breadcrumb>
            <br>
            <p class="file" @click="toggle(data.CompanysName)" title="Download">{{ data.CompanysName}}</p> 
            <br>
            <p class="file" @click="toggle(data.ProductsName)" title="Download">{{ data.ProductsName}}</p>
            <br>
            <p class="file" @click="toggle(data.SolutionsName)" title="Download">{{ data.SolutionsName}}</p>
            <br>
            <p class="file" @click="toggle(data.ExhibitionsName)" title="Download">{{ data.ExhibitionsName}}</p>  
        </div>  
    </template>
    <template v-else-if="data.TypeName  == 'Sales Representative'">
        <div class="news"  style="height:410px;">
            <Breadcrumb :headers="headers4"></Breadcrumb>  
        </div>  
    </template>

    <div class="ordering">
        <Breadcrumb :headers="headers3"></Breadcrumb>
        <p style="padding:30px 0;" class="file" @click="ordering">{{ data.Ordering}}</p>
        <label></label>    
    </div>
      <UpdateBox
      :initForm="updateForm"
      v-if="updateBlock"
      @close="updateBlock = false"
    ></UpdateBox>   
    <iframe id="ifile" name="ifile" :src="iframeUrl" style="display:none"></iframe>
          
  </div>
</template>

<script>
import UpdateBox from "../components/Dashboard/UpdateBox.vue";
import Breadcrumb from "../components/common/Breadcrumb.vue";
import { ACCOUNTGRADE } from "@/components/Account/data.js";
import { PARTNERGRADE } from "@/components/Partner/data.js";
export default {
    components: {
        Breadcrumb,
        UpdateBox
    }, 
    props:{
        id:{}
    },
    data() {
        return {
            data:{
                PartnerRecommend:{}
            },
            updateForm: {},
            partnerData:{},
            userDataList:[],
            iframeUrl:"",
            updateBlock: false,
            headers:[{label:"Level",path:"/dashboard"}],
            headers1:[{label:"Specially recommended for you",path:``}], 
            headers2:[{label:"The Latest Registration",path:"/projectRegistration"}],  
            headers3:[{label:"The Latest Ordering",path:"/ordering"}],
            headers4:[{label:"",path:``}]
        };
    },
   
    mounted () {
        this.getInfo();
        this.getUserInfo();
        this.getAccountBindingAll();
    },
    methods: {
        getInfo () {
            this.$http.get("getDashboardList",{
            },(data)=>{
                this.data = data = data.data;
                data.GradeName = PARTNERGRADE[data.Grade];
                data.TypeName = ACCOUNTGRADE[data.Type];
            });
        },
        getUserInfo () {
            this.$http.get("getAccountInfo",{},(data)=>{
                this.partnerData = data.data;
            });
        },
        getAccountBindingAll () {
            this.$http.get("getAccountBindingAll",{},(data)=>{
                this.userDataList = data.data;
            });
        },
        setPartnerEngineer (val) {
            this.updateBlock = true;
            this.updateForm = val;
            /*        this.$http.get("getPartnerInfo",{},(data)=>{
                this.userDataList = data.data;
              
            }); */
        },
        /* news () {
            this.$router.push(`/newsInfo?id=${this.data.NewsID}`);
        }, */ 
        projectRegistration () {
            this.$router.push("/projectRegistration");
        },
        ordering () {
            this.$router.push("/ordering");
        },
        toggle (data) {
            this.iframeUrl = `${this.$http.host}akuvoxwiki/download/partnerManage/marketingMaterials/${data}`;
        },
        partner () {
            this.$router.push("/partner");
        }
    }
};
</script>

<style lang="less" scoped>
    
        .le-bord {
            display: inline-block;
            width:calc(50% - 10px);
        }

        .level{
            width: 100%;
            box-sizing: border-box;
            padding: 15px 10px;
            font-size: 16px;
            background-color: #FFF;
            border-style :solid;
            border-width: 1px;
            border-color: #E0E0E0;
            box-shadow: 1px 3px 7px rgba(0, 0, 0, .08);
        }
        .news{
            width: calc(50% - 10px);
            padding: 15px 10px;
            display: inline-block;
            box-sizing: border-box;
            margin-left: 20px;
            vertical-align: top;
            font-size: 16px;
            background-color: #FFF;
            border-style :solid;
            border-width: 1px;
            border-color: #E0E0E0;
            box-shadow: 1px 3px 7px rgba(0, 0, 0, .08);
        }
        .news1{
            width: 37%;
            position: absolute;
            margin-left: 45%;
            margin-top: 3%;
           
            padding-left: 1%;
            padding-top: 0.2%;
            
            padding-bottom: 21%;
            font-size: 16px;
            background-color: #FFF;
            border-style :solid;
            border-width: 1px;
            border-color: #E0E0E0;
            box-shadow: 1px 3px 7px rgba(0, 0, 0, .08);
            }
        .registration{
            width: 100%;
            padding: 15px 10px;
            box-sizing: border-box;
            font-size: 16px;
            margin-top:20px;
            background-color: #FFF;
            border-style :solid;
            border-width: 1px;
            border-color: #E0E0E0;
            box-shadow: 1px 3px 7px rgba(0, 0, 0, .08);
        }
        .registration1{
            width: 37%;
            margin-left: 5%;
            margin-top: 14%;
             
            position: absolute;
            padding-left: 1%;
            padding-top: 0.2%;
            
            padding-bottom: 8.95%;
            font-size: 16px;
            background-color: #FFF;
            border-style :solid;
            border-width: 1px;
            border-color: #E0E0E0;
            box-shadow: 1px 3px 7px rgba(0, 0, 0, .08);
        }
        .registration2{
            width: 37%;
            margin-left: 5%;
            margin-top: 17.5%;
             
            position: absolute;
            padding-left: 1%;
            padding-top: 0.2%;
            
            padding-bottom: 6.5%;
            font-size: 16px;
            background-color: #FFF;
            border-style :solid;
            border-width: 1px;
            border-color: #E0E0E0;
            box-shadow: 1px 3px 7px rgba(0, 0, 0, .08);
        }
        .registration4{
            width: 37%;
            margin-left: 5%;
            margin-top: 14%;
             
            position: absolute;
            padding-left: 1%;
            padding-top: 0.2%;
            
            padding-bottom: 9.95%;
            font-size: 16px;
            background-color: #FFF;
            border-style :solid;
            border-width: 1px;
            border-color: #E0E0E0;
            box-shadow: 1px 3px 7px rgba(0, 0, 0, .08);
        }
        .ordering{
            margin-top: 20px;
            padding: 15px 10px;
            font-size: 16px;
            background-color: #FFF;
            border-style :solid;
            border-width: 1px;
            border-color: #E0E0E0;
            box-shadow: 1px 3px 7px rgba(0, 0, 0, .08);
        }
        .my-input{
            width: 10%;
            height: 30px;
            outline: none;
            border: 1px solid #dadada;
            padding: 0 12px;
            font-size: 16px;
            box-sizing: border-box;
            }
        .file{
            /* padding-left: 10px; */
            cursor: pointer;
            &:hover{
                color:#03a9f4;
            }
        }  
</style>

